import apiClient from 'services/apiClient';

export const fetchMetaFlowConfigTenants = (params = {}) =>
  apiClient.get('meta-flow-config', { params }).then((res) => res.data);

export const uploadMetaFlowPublicKey = (userId, force = false) =>
  apiClient
    .post(`meta-flow-config/${userId}/upload`, null, {
      params: force ? { force: 1 } : undefined,
    })
    .then((res) => res.data);
